module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "col-xs-12 col-sm-5"
  }, [_c('div', {
    staticClass: "calendar__info"
  }, [_c('div', {
    staticClass: "calendar__info"
  }, [_c('div', {
    staticClass: "calendar__info__item"
  }, [_c('h4', {
    staticClass: "calendar__info__title"
  }, [_vm._v(_vm._s(_vm.$t('LAST_PERIOD')))]), _vm._v(" "), _c('div', {
    staticClass: "calendar__info__date__wrapper"
  }, [_c('div', {
    staticClass: "calendar__info__date"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.lastPeriodDay, 'dd')))]), _vm._v(" "), _c('span', {
    staticClass: "date__day-number"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.lastPeriodDay, 'DD')))])]), _vm._v(" "), _c('div', {
    staticClass: "calendar__info__month"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.lastPeriodDay, 'MMM')) + " " + _vm._s(_vm._f("moment")(_vm.lastPeriodDay, 'YYYY')))])])]), _vm._v(" "), _c('div', {
    staticClass: "calendar__info__tooltip box-shadow"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('FIRST_PERIOD_DAY_INFO')) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "calendar__info__item"
  }, [_c('div', {
    staticClass: "next-examination__wrapper"
  }, [_c('h4', {
    staticClass: "calendar__info__title"
  }, [_vm._v(_vm._s(_vm.$t('LAST_BRASTER_EXAMINATION')) + ":")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "next-examination__date"
  }, [_vm._v("\n                        " + _vm._s(_vm.dateFormat(_vm.lastExamination.isoDate)) + "\n                    ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next-examination__legend next-examination__legend--transparent"
  }, [_c('img', {
    staticClass: "legend-img",
    attrs: {
      "src": require("../../assets/images/braster-logo-app.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64d6f2d2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/period-modules/last-period-and-examination.vue
// module id = 1213
// module chunks = 0